<div ui-row>
  <div ui-col>
    <ui-assignee-avatar [uiAssignee]="team" [uiSize]="'md'"></ui-assignee-avatar>
  </div>
  <div ui-col class="sp-ml-12">
    <div class="fs-32px bold lh-1 sp-mb-12">{{ title }}</div>
    <div class="fs-16px bold">{{ timeframe }}</div>
    <div class="text-color-gray-9">Update teammates for your work progress this week.</div>
  </div>
</div>

<ui-tabset>
  <ui-tab uiClosable [uiTitle]="'1. Questions'">
    <div>
      <div class="reflection" *ngFor="let question of questions" [ngSwitch]="question.type">
        <div *ngSwitchCase="reflectionQuestionType.textArea">
          <h5 class="sp-mt-32 sp-mb-12">{{ question.text }}</h5>
          <rich-text-editor [text]="question.answer" [readOnly]="readOnly"></rich-text-editor>
        </div>
      </div>
    </div>
  </ui-tab>

  <ui-tab uiClosable [uiTitle]="'2. Key Result updates'">
    <div class="sp-my-12">
      <ui-icon uiType="color:goal" class="fs-16px sp-mr-12"></ui-icon>
      <span class="bold">Quality is key</span>
      <span class="text-color-gray-8">Q3 2022</span>
    </div>

    <div class="kr-update sp-p-6" [ngClass]="{ 'sp-mb-12': !last }" *ngFor="let krUpdate of krUpdates; let last = last">
      <div ui-row [uiAlign]="'middle'" class="sp-mb-12">
        <ui-icon uiTheme="fill" uiType="metric" class="fs-16px sp-mr-12"></ui-icon>
        <span class="bold">{{ krUpdate.title }}</span>
        <gh-confidence-label class="ml-auto" [confidence]="krUpdate.confidence"></gh-confidence-label>
      </div>

      <gh-progress-bar [score]="krUpdate.value"></gh-progress-bar>

      <div class="text-color-gray-12 sp-mt-12">{{ krUpdate.comment }}</div>
    </div>
  </ui-tab>
</ui-tabset>

<button class="sp-mt-24" ui-button uiType="primary" [uiShape]="'round'" [disabled]="true">Next</button>
